import Session from "../models/session.model";
import IService from "./service";

const PERSISTENT_STORAGE_KEY = 'session.token';
const URL_AUTHORIZE = 'oauth/authorize';
const URL_SESSION = 'oauth/me';

export default class SessionService extends IService {
    /**
     * Getter
     * @returns {Storage}
     */
    get storage() {
        return this.config.storage;
    }

    /**
     * Getter
     * @returns {string}
     */
    get authorizeURL() {
        return this.$services.api.baseURL + URL_AUTHORIZE;
    }

    /**
     * Load session from persistent storage
     * @returns {string|null}
     */
    restoreSession() {
        this.session = this.storage.getItem(PERSISTENT_STORAGE_KEY);
        this.session = this.session || null;
        return this.session;
    }

    /**
     * Save session to persistent storage
     * @param session {string|null}
     */
    storeSession(session) {
        this.session = session;
        if (this.session) {
            this.storage.setItem(PERSISTENT_STORAGE_KEY, this.session);
        } else {
            this.storage.removeItem(PERSISTENT_STORAGE_KEY);
        }
    }

    /**
     * Remove stored session
     */
    removeSession() {
        this.storeSession(null);
    }

    /**
     * Load session data
     * @param [token] {string}
     * @returns {Promise<Session>}
     */
    async getSession(token) {
        let session = {};
        token = typeof token === 'undefined' ? this.session : token;
        if (token) {
            try {
                session = await this.$services.api
                    .create()
                    .withToken(token)
                    .get(URL_SESSION);
                session = session.data || {};
            } catch (error) {
                session = {};
            }
        }
        return new Session(session);
    }

    /**
     * Empty Session object
     * @returns {Session}
     */
    empty() {
        return new Session();
    }
}